export default [
    '#FE9200',
    '#68CCCA',
    '#73D8FF',
    '#AEA1FF',
    '#E27300',
    '#FCC400',
    '#B0BC00',
    '#68BC00',
    '#16A5A5',
    '#009CE0',
    '#7B64FF',
    '#FA28FF',
    '#9F0500',
    '#C45100',
    '#FB9E00',
    '#808900',
    // '#194D33',
    '#0C797D',
    '#0062B1',
    '#653294',
    '#AB149E',
    '#FFFFFF',
]